import { resetPlusStyleFeatures, toFreeStyle } from "../model/plusFeatures";
import { Site } from "../model/site";
import { api, hasActiveSubscription, Subscription } from "./api";

// Single choke point for every `api.publish` call in the app. Without an active
// PLUS subscription, a Keepo not yet on the air goes live in its simple version (every PLUS item:
// the top, colors of its own, background, buttons, fonts, alignment, the hidden brand) -
// see toFreeStyle. One already published (`wasPublished`) keeps the look it has: only the custom
// theme and the alignment are reset (resetPlusStyleFeatures), as always, so a live page doesn't
// change without notice. Whatever screen publishes (Pronto para publicar, Configurações). Callers
// should `setSite(...)` with the returned payload so local state matches what was
// actually published.
//
// Publishing also makes an inactive Keepo active again (`wasDisabled`), otherwise the
// published changes wouldn't be visible. Callers should then mark it as active locally.
// A refused reactivation (e.g. free Keepos limit) rejects like a publish error.
export const publishSite = async (
  siteId: string,
  site: Site,
  subscription?: Subscription,
  wasDisabled?: boolean,
  wasPublished?: boolean
): Promise<Site> => {
  const payload = hasActiveSubscription(subscription)
    ? site
    : wasPublished
      ? resetPlusStyleFeatures(site)
      : toFreeStyle(site);
  await api.publish(siteId, payload);
  if (wasDisabled) {
    await api.enableSite(siteId);
  }
  return payload;
};
